import { render } from "./QuestionOneScreen.vue?vue&type=template&id=5df8091e&scoped=true&lang=html"
import script from "./QuestionOneScreen.vue?vue&type=script&lang=js"
export * from "./QuestionOneScreen.vue?vue&type=script&lang=js"

import "./QuestionOneScreen.vue?vue&type=style&index=0&id=5df8091e&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/progressive/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df8091e"]])

export default __exports__